"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCycle = void 0;
const date_fns_1 = require("date-fns");
function getCycle(date, config) {
    const firstCycleStart = new Date(config.project_cycle_start);
    let currentCycleStart = firstCycleStart;
    const weeksBetweenCycles = config.project_cycle_duration_weeks + config.cooldown_duration_weeks;
    const weeksSinceFirstCycle = date_fns_1.differenceInWeeks(date, firstCycleStart);
    // Bugfix mondays start at odd weeks after the cycle start
    if (date_fns_1.getDay(date) === 1 &&
        (weeksSinceFirstCycle + 1) % config.bugfix_monday_recurrence_weeks === 0) {
        return {
            name: 'bugfix_monday',
            week: 1,
        };
    }
    if (weeksSinceFirstCycle >= weeksBetweenCycles) {
        const cyclesSinceFirst = Math.floor(weeksSinceFirstCycle / weeksBetweenCycles);
        currentCycleStart = date_fns_1.addWeeks(firstCycleStart, cyclesSinceFirst * weeksBetweenCycles);
    }
    const weeksSinceCurrentCycleStart = date_fns_1.differenceInWeeks(date, currentCycleStart);
    if (weeksSinceCurrentCycleStart < config.project_cycle_duration_weeks) {
        return {
            name: 'project',
            week: weeksSinceCurrentCycleStart + 1,
        };
    }
    else {
        return {
            name: 'cooldown',
            week: weeksSinceCurrentCycleStart + 1 - config.project_cycle_duration_weeks,
        };
    }
}
exports.getCycle = getCycle;
//# sourceMappingURL=cycle.js.map